import * as React from "react";
import { JSX } from "react/jsx-runtime";
const Weather = (props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg
    width={55}
    height={55}
    viewBox="0 0 55 55"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_633_3782)">
      <path
        d="M47 22C47 29.7319 40.7319 36 33 36C25.2676 36 19 29.7319 19 22C19 14.2681 25.2676 8 33 8C40.7319 8 47 14.2681 47 22Z"
        fill="#FDD020"
      />
      <path
        d="M33 6C32.4473 6 32 5.55225 32 5V1C32 0.447754 32.4473 0 33 0C33.5522 0 34 0.447754 34 1V5C34 5.55225 33.5522 6 33 6Z"
        fill="#FDD020"
      />
      <path
        d="M54 23H50C49.4473 23 49 22.5522 49 22C49 21.4478 49.4473 21 50 21H54C54.5522 21 55 21.4478 55 22C55 22.5522 54.5522 23 54 23Z"
        fill="#FDD020"
      />
      <path
        d="M43.755 34.2629C43.0738 34.2629 42.3939 34.332 41.7263 34.4682C41.2229 31.9253 39.5953 29.7562 37.3101 28.5821C35.0253 27.408 32.3345 27.3587 30.0088 28.4481C27.9042 22.5809 21.4983 19.5515 15.701 21.6815C9.90359 23.812 6.91032 30.2951 9.01498 36.1624C3.93661 36.3249 -0.0748851 40.5785 0.00106076 45.7204C0.0774615 50.8619 4.21356 54.9917 9.29466 55H43.755C49.4128 55 54 50.3579 54 44.6315C54 38.905 49.4128 34.2629 43.755 34.2629Z"
        fill="#A3D4F7"
      />
      <path d="M20 10L16 6L20 10Z" fill="#FDD020" />
      <path
        d="M20.0025 11C19.7374 11 19.484 10.8947 19.2969 10.7076L15.3049 6.71577C15.0451 6.4653 14.9413 6.09399 15.0325 5.74509C15.1241 5.39619 15.3965 5.1238 15.7454 5.03268C16.0943 4.94107 16.4651 5.04534 16.7161 5.30458L20.7081 9.29644C20.9932 9.58199 21.0784 10.0113 20.924 10.3841C20.7695 10.7568 20.406 11 20.0025 11Z"
        fill="#FDD020"
      />
      <path d="M45 10L49 6L45 10Z" fill="#FDD020" />
      <path
        d="M44.998 11C44.594 11 44.2305 10.7568 44.076 10.3841C43.9215 10.0113 44.0068 9.58199 44.2924 9.29644L48.2844 5.30458C48.5349 5.04534 48.9057 4.94107 49.2546 5.03268C49.6035 5.1238 49.8764 5.39619 49.9675 5.74509C50.0587 6.09399 49.9549 6.4653 49.6956 6.71577L45.7036 10.7076C45.5165 10.8947 45.2626 11 44.998 11Z"
        fill="#FDD020"
      />
    </g>
    <defs>
      <clipPath id="clip0_633_3782">
        <rect width={55} height={55} fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default Weather;
